import type { ComponentPropsWithoutRef } from 'react';
import { container } from './Container.css';

export type ContainerProps = ComponentPropsWithoutRef<'div'>;

export function Container({ className, ...rest }: ContainerProps) {
  const classes = [container, className].filter(Boolean).join(' ');
  return <div className={classes} {...rest} />;
}
